import { Button, Dialog, DialogActions, DialogContent, MenuItem, TextField } from "@mui/material";
import { Component } from "react";
import DialogTitleWithCloseButton from "../../../../components/DialogTitleWithCloseButton";
import AttachmentInput from "../../../../components/AttachmentInput";
import { DOCUMENT_NAME, PAYMENT_TYPE } from "../../../../../../shared/constants";
import { hideLoading, showLoading } from "../../../../loading";
import { errorToast } from "../../../../toast";
import request from "../../../../request";
import swal from "sweetalert";
import EditableTextbox from "../../../../components/EditableTextbox";
import SearchItem from "../../../../components/SearchItem";


export default class ActivationModal extends Component {

   state = {
      contract: null,
      depositPaymentType: '',
      depositPoP: null,
      depositAmount: 0,
      bankAccount: null
   }

   submit = async () => {
      
      // validate
      const txtDepositAmount = document.getElementById('txt-deposit-amount');
      const { contract, depositPaymentType, depositPoP, depositAmount, bankAccount } = this.state;

      if (!contract) {
         errorToast("Please select the loan contract");
         return;
      }

      if (!depositAmount) {
         errorToast("Please enter the deposit amount");
         return txtDepositAmount.focus();
      }

      if (depositAmount < this.props.depositAmount) {
         errorToast("Deposit amount cannot be less than the previously agreed on amount");
         return txtDepositAmount.focus();
      }

      if (!depositPaymentType) {
         errorToast("Please select the deposit payment type");
         return;
      }

      if (!depositPoP) {
         errorToast("Please select the deposit PoP");
         return;
      }

      if (!bankAccount) {
         errorToast("Please select bank account")
         return;
      }

      try {

         showLoading();

         let amount;

         if (depositAmount !== this.props.depositAmount)
            amount = depositAmount;

         const data = {
            contract: {
               name: DOCUMENT_NAME.LOAN.CONTRACT,
               base64: contract.base64,
               ext: contract.ext
            },
            deposit: {
               payment_type: depositPaymentType,
               proof_of_payment: depositPoP,
               amount,
               bank_account: bankAccount.id
            }
         }

         const res = await request.post(`/api/credit/loans/${this.props.loanId}/activation`, data);
         this.props.onClose(res.data);

      } catch (error) {
         swal('Error', error.message, 'error');
      } finally {
         hideLoading();
      }
   }

   componentDidMount() {
      this.setState({
         depositAmount: this.props.depositAmount
      })
   }

   render() {
      return <Dialog open>
         <DialogTitleWithCloseButton onClose={() => this.props.onClose()}>
            Activate Loan
         </DialogTitleWithCloseButton>

         <DialogContent dividers>
            <div className="w-[250px] max-w-full flex flex-col gap-8">
               <AttachmentInput
                  label="Loan contract"
                  onChange={contract => this.setState({ contract })}
                  name={this.state.contract?.name}
               />
               <EditableTextbox
                  id="txt-deposit-amount"
                  label="Deposit amount"
                  variant="outlined"
                  size="small"
                  value={this.state.depositAmount}
                  defaultValue={this.props.depositAmount}
                  onChange={depositAmount => this.setState({ depositAmount })}
                  type="number"
               />
               <TextField
                  id="txt-desosit-payment-type"
                  label="Deposit payment type"
                  variant="outlined"
                  fullWidth
                  size="small"
                  value={this.state.depositPaymentType}
                  onChange={e => this.setState({ depositPaymentType: e.target.value })}
                  select
               >
                  {
                     Object
                        .values(PAYMENT_TYPE)
                        .map(type => <MenuItem key={type} value={type}>
                           {type.replace(/[-_]/g, ' ').toUpperCase()}
                        </MenuItem>)
                  }
               </TextField>
               <AttachmentInput
                  label="Deposit PoP"
                  onChange={depositPoP => this.setState({ depositPoP })}
                  name={this.state.depositPoP?.name}
               />
               <SearchItem
                  label="Bank account"
                  fetchData={
                     async () => {
                        const res = await request.get('/api/general/quickbooks/bank-accounts');
                        return res.data.accounts;
                     }
                  }
                  transformOption={opt => ({ ...opt, label: opt.name })}
                  size="small"
                  onChange={bankAccount => this.setState({ bankAccount })}
                  value={this.state.bankAccount}
               />
            </div>
         </DialogContent>

         <DialogActions>
            <Button onClick={this.submit} variant="contained" size="small">
               SUBMIT
            </Button>
         </DialogActions>
      </Dialog>
   }
}